<div class="modal-header sticky-header d-flex justify-content-between align-items-center" *ngIf="!isOtherDialog">
  <h5 class="modal-title">Edit Permissions - {{data?.memberName}}</h5>
  <div>
    <button type="button" class="btn col-auto me-2 btn-secondary" (click)="dismissPopup()"><i class="fa fa-times"></i> Cancel</button>
    <button type="button" class="btn col-auto btn-primary" (click)="save()"><i class="fa fa-save"></i> Save</button>
  </div>
</div>
<div class="modal-body">
  <form [formGroup]="formGroup">
    <div class="table-responsive data-grid sticky-header-table-advanced mt-4" [style.--sticky-top]="stickyTop">
      <table mat-table
             class="table table-hover"
             matSort="accsort"
             [dataSource]="dataSource"
             infiniteScroll
             [infiniteScrollDistance]="2"
             [infiniteScrollThrottle]="20"
             (scrolled)="onTableScroll()">
        <!-- Sale Image URL Column -->
        <ng-container matColumnDef="saleImageUrl">
          <th mat-header-cell
              class="sale-image-heading w-3 pe-2 col-auto"
              *matHeaderCellDef
              mat-sort-header></th>
          <td mat-cell *matCellDef="let element" class="py-2 pe-2"   [ngClass]="{ 'all-sales-row': !element.saleName }">
            <img [src]="element?.saleImageUrl"
                 *ngIf="element?.saleImageUrl; else placeholder"
                 width="45" />
            <ng-template #placeholder>
              <img src="assets/images/horse-no-img.jpg"
                   class="default-img"
                   width="45" />
            </ng-template>
          </td>
        </ng-container>
        <ng-container matColumnDef="saleName">
          <th mat-header-cell
              class="sale-name-heading w-10 col-4"
              *matHeaderCellDef
              mat-sort-header>
            sale <i class="fa fa-sort ms-1"></i>
          </th>
          <td mat-cell *matCellDef="let element" class="less-height-1-8-rem" [ngClass]="{ 'all-sales-row': !element.saleName }">
            <div class="border-0 ps-0">
              <div class="title-wrap d-sm-flex align-items-center">
                <div class="sale-title" style="position: relative">
                  <span class=" text-primary fw-bold">
                    {{ element?.saleName ? element?.saleName : 'All Sales' }}
                  </span><br />
                  <span>{{ element?.location }}</span>
                </div>
              </div>
            </div>
          </td>
        </ng-container>
        <!-- View Access Column -->
        <ng-container matColumnDef="isViewAccess">
          <th mat-header-cell *matHeaderCellDef> View Access </th>
          <td mat-cell *matCellDef="let element; let i = index" [ngClass]="{ 'all-sales-row': !element.saleName }">
            <mat-checkbox [formControl]="getControl(i, 'isViewAccess')">
            </mat-checkbox>
          </td>
        </ng-container>
        <!-- Submit Access Column -->
        <ng-container matColumnDef="isSubmitAccess">
          <th mat-header-cell *matHeaderCellDef> Submit Access </th>
          <td mat-cell *matCellDef="let element; let i = index" [ngClass]="{ 'all-sales-row': !element.saleName }">
            <mat-checkbox [formControl]="getControl(i, 'isSubmitAccess')"></mat-checkbox>
          </td>
        </ng-container>
        <!-- Add similar width classes to other columns if they have them -->

        <tr mat-header-row
            *matHeaderRowDef="displayedColumns;"></tr>
        <tr mat-row
            *matRowDef="let row; columns: displayedColumns; let saleIndex = index"
            class="border-start-0 border-end-0 pointer pt-2"></tr>
      </table>
    </div>
  </form>
</div>
